import { Component, inject } from '@angular/core'
import { NotificationService } from './notification.service'
import { BricksAlertComponent, BricksAlertContainerComponent } from '@enbw_bricks/ui'
import { KeyValuePipe } from '@angular/common'

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  imports: [BricksAlertComponent, KeyValuePipe, BricksAlertContainerComponent],
})
export class NotificationComponent {
  private readonly notificationService = inject(NotificationService)

  readonly notifications = this.notificationService.notifications

  dismiss(id: string): void {
    this.notificationService.dismiss(id)
  }
}
